import Email from "~/pages/email/Index.vue";

export default [
  {
    path: "/email/:emailId",
    component: Email,
    name: "email.show",
    props: {
      showSingle: true,
    },
  },
  {
    path: "/email",
    component: Email,
    name: "email.index",
  },
];
